import axios from "axios";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useState } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useApi = (path, params) =>
  useQuery({
    queryKey: [path, params],
    queryFn: async () => (await axios.get(`${API}${path}`, { params })).data,
    retry: 1,
    placeholderData: keepPreviousData,
  });

// List with search + "load more" (grows the limit by `step`)
export const usePagedList = (path, extra = {}, step = 24) => {
  const [limit, setLimit] = useState(step);
  const [q, setQ] = useState("");
  const query = useApi(path, { ...extra, limit, q: q || undefined });
  const items = query.data || [];
  return {
    ...query, items, q, limit,
    setQ: (v) => { setQ(v); setLimit(step); },
    hasMore: items.length >= limit,
    loadMore: () => setLimit((l) => l + step),
  };
};

export const postApi = async (path, body) => (await axios.post(`${API}${path}`, body)).data;

export const formatEventDate = (iso) => {
  const d = new Date(iso);
  const day = d.toLocaleDateString("fr-FR", { weekday: "short", day: "2-digit", month: "long", year: "numeric" });
  return day.charAt(0).toUpperCase() + day.slice(1);
};

export const formatTime = (iso) => new Date(iso).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });

export const formatShortDate = (iso) =>
  new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });

export const isPast = (iso) => new Date(iso) < new Date();
